import { Injectable } from '@angular/core';

export interface AppConfig {
  apiURL: string;
  IW_FRONTEND_URL: string;
  DAPP_API_URL: string;
  ONECLICK_URL: string;
}

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private config!: AppConfig;

  load(): Promise<void> {
    return fetch('/assets/config.json')
      .then(res => {
        if (!res.ok) {
          throw new Error('No se pudo cargar config.json');
        }
        return res.json();
      })
      .then(data => {
        this.config = data;
      });
  }

  get settings(): AppConfig {
    return this.config;
  }
}
